<main class="c-main">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-12"></div>
            <div class="alert alert-danger" role="alert" *ngFor="let erro of mensagemErros">
                {{ erro }}
            </div>
        </div>
        <div class="mat-elevation-z8">
            <mat-card>
                <mat-card-title>
                    <mat-icon>attach_money</mat-icon>
                    Vendas
                </mat-card-title>
                <mat-card>
                    <!-- //inicio da tabela -->
                    <div class="row"> 
                        <div class="col-4">                    
                                <mat-form-field appearance="fill" style="width: 100%;">
                                    <mat-label>Consulta Por</mat-label>
                                    <mat-select id="tipoFiltro" name="tipoFiltro" [(value)]="tipoFiltro" required>
                                        <mat-option [value]="tipoFiltro" *ngFor="let tipoFiltro of tipoFiltros">{{tipoFiltro}}
                                        </mat-option>
                                    </mat-select>
                                </mat-form-field>
                        </div>
                        <div class="col-6" *ngIf="tipoFiltro == 'Periodo'" style="display: flex;">
                            <div class="col-6">
                                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                    <mat-label>Inicio</mat-label>
                                    <input id="dataInicio" matInput [matDatepicker]="dataInicio" name="dataInicio" mask="00/00/0000" style="width: 80%;">                                
                                        <mat-datepicker-toggle matIconSuffix [for]="dataInicio" style="position: absolute;top: -13px;">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #dataInicio></mat-datepicker>
                                </mat-form-field>
                            </div>
                            <div class="col-6">
                                <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                    <mat-label>Fim</mat-label>
                                    <input id="dataFim" matInput [matDatepicker]="dataFim" name="dataFim" mask="00/00/0000" style="width: 80%;">                                
                                        <mat-datepicker-toggle matIconSuffix [for]="dataFim" style="position: absolute;top: -13px;">
                                        </mat-datepicker-toggle>
                                        <mat-datepicker #dataFim></mat-datepicker>
                                </mat-form-field>
                            </div>
                        </div>
                        <div class="col-6" *ngIf="tipoFiltro == 'Pagamento'">
                            <mat-form-field class="full-width" appearance="fill" style="width: 100%;">
                                <mat-label>Telefone</mat-label>
                                <input [(ngModel)]="parametroConsulta" name="parametroConsulta" mask="(00) 0 0000-0000 || (00) 0000-0000" matInput>
                            </mat-form-field>
                        </div>  
                        <div class="col-2">
                                    <button (click)="consultar()" mat-raised-button color="primary" style="line-height: 51px;width: 100%;">
                                        <mat-icon>search</mat-icon>
                                        Consultar
                                    </button>                                        
                        </div>

                </div>
                    <table mat-table [dataSource]="sales" class="full-width">
                        <!-- Coluna ID -->
                        <ng-container matColumnDef="id">
                            <th mat-header-cell *matHeaderCellDef> ID </th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.id }} </td>
                        </ng-container>

                        <ng-container matColumnDef="cliente">
                            <th mat-header-cell *matHeaderCellDef> Cliente </th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.clientName }} </td>
                        </ng-container>

                        <!-- Coluna Nome -->
                        <ng-container matColumnDef="amount">
                            <th mat-header-cell *matHeaderCellDef> Cobrado </th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.amount | currency:'BRL'}} </td>
                        </ng-container>

                        <!-- Coluna preco -->
                        <ng-container matColumnDef="amountPaid">
                            <th mat-header-cell *matHeaderCellDef>Pago</th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.amountPaid + sale.amountPaidTwo | currency:'BRL'}} </td>
                        </ng-container>

                        <!-- Coluna preco -->
                        <ng-container matColumnDef="difference">
                            <th mat-header-cell *matHeaderCellDef>Troco</th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.difference | currency:'BRL'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="payment">
                            <th mat-header-cell *matHeaderCellDef> Pagamento </th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.payment }} | {{sale.paymentTwo}} </td>
                        </ng-container>

                        <ng-container matColumnDef="createdAt">
                            <th mat-header-cell *matHeaderCellDef> Data Pagamento </th>
                            <td mat-cell *matCellDef="let sale"> {{ sale.createdAt | date : 'dd/MM/yyyy HH:mm'}} </td>
                        </ng-container>

                        <ng-container matColumnDef="excluir">
                            <th mat-header-cell *matHeaderCellDef>Excluir</th>
                            <td mat-cell *matCellDef="let sale">
                                <button (click)="openDialog(sale.id)" mat-icon-button color="warn">
                                    <mat-icon>delete</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="detalhe">
                            <th mat-header-cell *matHeaderCellDef>Detalhe</th>
                            <td mat-cell *matCellDef="let sale">
                                <button (click)="openDialogDetalhe(sale)" mat-icon-button style="color: #31aa53;">
                                    <mat-icon>manage_search</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <ng-container matColumnDef="nota">
                            <th mat-header-cell *matHeaderCellDef>Nota Fiscal</th>
                            <td mat-cell *matCellDef="let sale">
                                <button (click)="openDialogNotaFiscal(sale.id)" mat-icon-button style="color: #aa319e;">
                                    <mat-icon>description</mat-icon>
                                </button>
                            </td>
                        </ng-container>

                        <!-- definir como vai ser as linhas e a ordem das colunas -->
                        <tr mat-header-row *matHeaderRowDef="ordemColunasTabela"></tr>
                        <tr mat-row *matRowDef="let row; columns: ordemColunasTabela;"></tr>
                    </table>

                    <!-- paginação -->
                    <mat-paginator [length]="totalElementos" [pageSize]="tamanho" [pageSizeOptions]="pageSizeOptions"
                        (page)="paginar($event)">
                        <!-- evento de paginar -->
                    </mat-paginator>

                </mat-card>
            </mat-card>
        </div>
    </div>
</main>